export default __webpack_public_path__ + "static/media/xls.c82c6d3c.svg";